import { useState, type ReactNode } from "react";
import { directoryMatches } from "../../../shared/src/page-directory";
import { Input } from "./ui-kit/forms";

/** Search already-authorized discovery cards; typing makes no content request. */
export function SearchableCards({
  id,
  label,
  cards,
  mobile = "stack",
  source,
}: {
  id: string;
  label: string;
  cards: { id: string; title: string; summary: string; url: string; content: ReactNode }[];
  mobile?: "stack" | "keep";
  /** The list's feed, which names what it counts: pages, or a matchup library's guides. */
  source?: string;
}) {
  const guides = source === "matchups";
  const [query, setQuery] = useState("");
  const shown = cards.filter((card) => directoryMatches(card, query));
  return (
    <>
      <div className="drate-page-directory-controls">
        <Input
          id={`directory-search-${id}`}
          name="search"
          label={label}
          hideLabel
          type="search"
          placeholder={label}
          onChange={(event) => setQuery(event.currentTarget.value)}
          aria-controls={`directory-results-${id}`}
        />
        <p role="status" aria-live="polite">
          {shown.length}{" "}
          {guides
            ? shown.length === 1
              ? "guide"
              : "guides"
            : shown.length === 1
              ? "page"
              : "pages"}
          {query ? ` matching “${query}”` : ""}
        </p>
      </div>
      <div
        id={`directory-results-${id}`}
        className="drate-page-repeater"
        data-page-mobile={mobile}
        data-page-source={source}
      >
        {shown.map((card) => card.content)}
      </div>
      {!shown.length && (
        <p className="drate-page-directory-empty">
          {guides
            ? "No guides match your search. Try another champion."
            : "No pages match your search. Try another name."}
        </p>
      )}
    </>
  );
}
